import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../core/services/toast.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed top-4 right-4 z-[100] w-full max-w-xs space-y-3">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="toast-item relative w-full p-4 pr-10 rounded-lg shadow-lg flex items-start gap-3 border"
          [class.bg-green-100]="toast.type === 'success'" [class.dark:bg-green-800/50]="toast.type === 'success'" [class.border-green-400]="toast.type === 'success'" [class.dark:border-green-600]="toast.type === 'success'"
          [class.bg-red-100]="toast.type === 'error'" [class.dark:bg-red-800/50]="toast.type === 'error'" [class.border-red-400]="toast.type === 'error'" [class.dark:border-red-600]="toast.type === 'error'"
          [class.bg-blue-100]="toast.type === 'info'" [class.dark:bg-blue-800/50]="toast.type === 'info'" [class.border-blue-400]="toast.type === 'info'" [class.dark:border-blue-600]="toast.type === 'info'"
          role="alert"
        >
          <div class="flex-shrink-0 text-xl">
            @switch (toast.type) {
              @case ('success') { <i class="fa-solid fa-circle-check text-green-500"></i> }
              @case ('error') { <i class="fa-solid fa-circle-xmark text-red-500"></i> }
              @case ('info') { <i class="fa-solid fa-circle-info text-blue-500"></i> }
            }
          </div>
          <div 
            class="flex-1 text-sm font-medium"
            [class.text-green-800]="toast.type === 'success'" [class.dark:text-green-200]="toast.type === 'success'"
            [class.text-red-800]="toast.type === 'error'" [class.dark:text-red-200]="toast.type === 'error'"
            [class.text-blue-800]="toast.type === 'info'" [class.dark:text-blue-200]="toast.type === 'info'"
            [innerHTML]="toast.message"
          >
          </div>
          <button 
            (click)="toastService.removeToast(toast.id)" 
            class="absolute top-2 right-2 w-7 h-7 flex items-center justify-center rounded-full transition-colors"
            [class.text-green-600]="toast.type === 'success'" [class.hover:bg-green-200/50]="toast.type === 'success'" [class.dark:text-green-300]="toast.type === 'success'" [class.dark:hover:bg-green-500/20]="toast.type === 'success'"
            [class.text-red-600]="toast.type === 'error'" [class.hover:bg-red-200/50]="toast.type === 'error'" [class.dark:text-red-300]="toast.type === 'error'" [class.dark:hover:bg-red-500/20]="toast.type === 'error'"
            [class.text-blue-600]="toast.type === 'info'" [class.hover:bg-blue-200/50]="toast.type === 'info'" [class.dark:text-blue-300]="toast.type === 'info'" [class.dark:hover:bg-blue-500/20]="toast.type === 'info'"
            aria-label="Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes toast-in-right {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .toast-item {
      animation: toast-in-right 0.3s ease-out forwards;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  toastService = inject(ToastService);
}
